AU.siteImproveNocrawl = {
    init: function () {
        // Prevents SiteImprove from crawling the cookie banner
        window.addEventListener("CookieScriptLoaded", function () {
            try {
                const cookieBanner = document.querySelector('#cookiescript_injected_wrapper');
                if (cookieBanner) {
                    cookieBanner.classList.add('SI-CONTENT-NO');
                }
            } catch (e) {
                // Do nothing on error
            }
        });
    }
}

